import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';

import { ModalContent, ModalActions } from 'components/Modal';
import {
  Input,
  Button,
  Checkbox,
} from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { commandWorkspaceAccountCreate } from 'containers/ConnectionManager/actions';

import {
  FormField,
  CheckBoxContainer,
  RolesErrorLabel,
} from './styles';
import messages from './messages';

class CreateAccountModal extends React.Component {
  state = {
    givenName: '',
    familyName: '',
    honorificPrefix: '',
    email: '',
    password: '',
    roles: [],
    givenNameFeedback: '',
    familyNameFeedback: '',
    emailFeedback: '',
    passwordFeedback: '',
    rolesFeedback: '',
    isValid: false,
  };

  onAccountCreate = () => {
    const inputFields = pick(this.state, [
      'givenName',
      'familyName',
      'honorificPrefix',
      'email',
      'password',
      'roles',
    ]);

    const { createAccount } = this.props;
    createAccount(inputFields);
  }

  checkAllFieldsNotEmpty = () => {
    const inputFields = pick(this.state, [
      'givenName',
      'familyName',
      'email',
      'password',
      'roles',
    ]);

    const keys = Object.keys(inputFields);

    const isValid =
      keys.filter((key) =>
        this.state[key].length)
        .length === keys.length;

    this.setState({
      isValid,
    });
  }

  handleInputChange = (key, value) => {
    this.setState({
      [key]: value,
      [`${key}Feedback`]: !value.length ? intl.formatMessage(messages[`${key}Feedback`]) : '',
    }, () => this.checkAllFieldsNotEmpty());
  }

  handleRolesChange = (e) => {
    let roles = [...this.state.roles];
    if (e.target.checked) {
      roles.push(e.target.value.toUpperCase());
    } else {
      roles = roles.filter((role) => role !== e.target.value.toUpperCase());
    }

    this.handleInputChange('roles', roles);
  }

  render() {
    return (
      <React.Fragment>
        <ModalContent>
          <FormField>
            <Input
              label={intl.formatMessage(messages.givenName)}
              onChange={(e) => this.handleInputChange('givenName', e.target.value.trim())}
              feedback={this.state.givenNameFeedback}
            />
          </FormField>
          <FormField>
            <Input
              label={intl.formatMessage(messages.familyName)}
              onChange={(e) => this.handleInputChange('familyName', e.target.value.trim())}
              feedback={this.state.familyNameFeedback}
            />
          </FormField>
          <FormField>
            <Input
              label={intl.formatMessage(messages.prefix)}
              onChange={(e) => this.handleInputChange('honorificPrefix', e.target.value.trim())}
            />
          </FormField>
          <FormField>
            <Input
              label={intl.formatMessage(messages.email)}
              onChange={(e) => this.handleInputChange('email', e.target.value.trim())}
              feedback={this.state.emailFeedback}
            />
          </FormField>
          <FormField>
            <Input
              label={intl.formatMessage(messages.defaultPassword)}
              onChange={(e) => this.handleInputChange('password', e.target.value.trim())}
              feedback={this.state.passwordFeedback}
            />
          </FormField>
          <FormField>
            <Input.Label>{intl.formatMessage(messages.roles)}</Input.Label>
            <CheckBoxContainer>
              <Checkbox label={intl.formatMessage(messages.rolesAdmin)} value="admin" onChange={this.handleRolesChange} />
              <Checkbox label={intl.formatMessage(messages.rolesInstructor)} value="aero_instructor" onChange={this.handleRolesChange} />
              <Checkbox label={intl.formatMessage(messages.rolesDeveloper)} value="developer" onChange={this.handleRolesChange} />
              {<RolesErrorLabel>{this.state.rolesFeedback}</RolesErrorLabel>}
            </CheckBoxContainer>
          </FormField>
        </ModalContent>
        <ModalActions>
          <Button primary onClick={this.onAccountCreate} disabled={!this.state.isValid}>{intl.formatMessage(messages.createAccount)}</Button>
        </ModalActions>
      </React.Fragment>
    );
  }
}

CreateAccountModal.propTypes = {
  onDismiss: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
  createAccount: PropTypes.func,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  createAccount: (account) => {
    const { onDismiss } = ownProps;
    const additionalCallbacks = [onDismiss];
    dispatch(commandWorkspaceAccountCreate(account, {
      additionalCallbacks,
    }));
  },
});

export default connect(null, mapDispatchToProps)(CreateAccountModal);
